import { createContext } from 'react';
export const DraggingContext = createContext(false);
DraggingContext.displayName = 'DraggingContext';
export const { Provider: DraggingProvider, Consumer: DraggingConsumer } = DraggingContext;
